import { configureStore } from '@reduxjs/toolkit';
import streamReducer from './stream/stream-slice';
import chatReducer from './chat/chat-slice';

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    stream: streamReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['stream/setPeerConnection'],
        ignoredPaths: ['stream.peerConnection'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
